import React from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TopNav from '../components/TopNav';
import SideMenuTemplate from './templates/SideMenuTemplate';
import { Routes as AppRoutes } from '../utils/constants/routes';
import { Icons } from '../utils/constants/icons';

const drawerLinks = [
  { icon: Icons.GRID_VIEW, label: 'Summary', path: AppRoutes.INVENTORY },
  { icon: Icons.SINGLE_PORTFOLIO, label: 'Portfolios', path: AppRoutes.INVENTORY_PORTFOLIOS },
  { icon: Icons.SINGLE_APPLICATION, label: 'Applications', path: AppRoutes.INVENTORY_APPLICATIONS },
  { icon: Icons.SINGLE_COMPONENT, label: 'Components', path: AppRoutes.INVENTORY_COMPONENTS },
  { icon: Icons.CAPABILITIES, label: 'Capabilities', path: AppRoutes.INVENTORY_CAPABILITIES },
  { icon: Icons.SINGLE_BUSINESS, label: 'Businesses', path: AppRoutes.INVENTORY_BUSINESSES },
  { icon: Icons.VENDOR, label: 'Vendors', path: AppRoutes.INVENTORY_VENDORS },
  { icon: Icons.SINGLE_TECHNOLOGY, label: 'Technologies', path: AppRoutes.INVENTORY_TECHNOLOGIES },
  { icon: Icons.SINGLE_SERVICE, label: 'Services', path: AppRoutes.INVENTORY_SERVICES },
];

const Wrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
});

const ContentWrapper = styled(Box)({
  flexGrow: 1,
  paddingTop: 64,
});

export const InventoryLayout = () => (
  <Wrapper>
    <TopNav />
    <ContentWrapper>
      <SideMenuTemplate title="Inventory" links={drawerLinks} content={<Outlet />} />
    </ContentWrapper>
  </Wrapper>
);
